module.exports = __webpack_public_path__ + "img/logo_biocloudaurum_color.989da657.png";